// 9fbef606107a605d69c0edbcd8029e5d 
export const defaultCountries = [
  {
    id: 'US',
    currencyId: 'USD',
    displayName: 'United States',
    siteId: 'us',
  },
  {
    id: 'CA',
    currencyId: 'CAD',
    displayName: 'CANADA',
    siteId: 'ca',
  },
];

export const defaultCurrencies = [
  {
    id: 'USD',
    displayName: 'Dollars',
    exchangevalue: '1.0',
    merchantMargin: '1.0',
  },
  {
    id: 'CAD',
    displayName: 'Canada Dollar',
    exchangevalue: '1.0',
    merchantMargin: '1.0',
  },
];

export const USA_VALUES = {
  currency: 'USD',
  currencySymbol: '$',
  countryCode: 'US',
  siteId: 'US',
};

export default {
  defaultCountries,
  defaultCurrencies,
};
